import Cookies from "js-cookie";
import randomBytes from "randombytes";
import { AYANA_SESSION } from "store/constants/actions";
import { getDomainName } from "./getDomainName";

const INVALID_VALUES = [undefined, null, NaN, "undefined", "null", "NaN"];
type CookieValue = string | undefined;
const randomString = () => randomBytes(16).toString("hex");

const sanitizeValue = (value: CookieValue): string => {
  if (INVALID_VALUES.includes(value) || !value) {
    return randomString();
  } else {
    return value;
  }
};

const AyanaSessionCookieSanitizer = {
  read: (value: string, name: string): string => {
    const sValue = sanitizeValue(value);
    if (name === AYANA_SESSION && sValue !== value) {
      cookies.set(AYANA_SESSION, sValue);
      return Cookies.converter.read(sValue, name);
    } else {
      return Cookies.converter.read(value, name);
    }
  },

  write: (value: string, name: string): string => {
    if (name === AYANA_SESSION) {
      return Cookies.converter.write(sanitizeValue(value), name);
    } else {
      return Cookies.converter.write(value, name);
    }
  },
};

const cookies = Cookies.withAttributes({
  expires: 2,
  path: "/",
  domain: getDomainName(),
}).withConverter(AyanaSessionCookieSanitizer);

export const getSessionId = (): CookieValue => {
  return cookies.get(AYANA_SESSION);
};

export const setSessionId = (value: string): CookieValue => {
  return cookies.set(AYANA_SESSION, value);
};

export const getOrSetSessionId = (): CookieValue => {
  let sessionId = getSessionId();

  if (sessionId) {
    return sessionId;
  } else {
    setSessionId(randomString());
    sessionId = getSessionId();
    return sessionId;
  }
};
